function DeleteLineIcon({ className }) {
  return (
    <svg className={`ic ${className}`} viewBox="0 0 25 27" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.442 6.85009C23.417 6.85009 23.3795 6.85009 23.342 6.85009C16.7295 6.18759 10.1295 5.93759 3.59197 6.60009L1.04197 6.85009C0.516972 6.90009 0.0544721 6.52509 0.0044721 6.00009C-0.0455279 5.47509 0.329472 5.02509 0.841972 4.97509L3.39197 4.72509C10.042 4.05009 16.7795 4.31259 23.5295 4.97509C24.042 5.02509 24.417 5.48759 24.367 6.00009C24.3295 6.48759 23.917 6.85009 23.442 6.85009Z"
        fill="currentColor"
      />
      <path
        d="M7.81733 5.5875C7.76733 5.5875 7.71733 5.5875 7.65483 5.575C7.15483 5.4875 6.80483 5 6.89233 4.5L7.16733 2.8625C7.36733 1.6625 7.64233 0 10.5548 0H13.8298C16.7548 0 17.0298 1.725 17.2173 2.875L17.4923 4.5C17.5798 5.0125 17.2298 5.5 16.7298 5.575C16.2173 5.6625 15.7298 5.3125 15.6548 4.8125L15.3798 3.1875C15.2048 2.1 15.1673 1.8875 13.8423 1.8875H10.5673C9.24233 1.8875 9.21733 2.0625 9.02983 3.175L8.74233 4.8C8.66733 5.2625 8.26733 5.5875 7.81733 5.5875Z"
        fill="currentColor"
      />
      <path
        d="M16.2044 26.875H8.17939C3.81689 26.875 3.64189 24.4625 3.50439 22.5125L2.69189 9.92497C2.65439 9.41247 3.05439 8.96247 3.56689 8.92497C4.09189 8.89997 4.52939 9.28747 4.56689 9.79997L5.37939 22.3875C5.51689 24.2875 5.56689 25 8.17939 25H16.2044C18.8294 25 18.8794 24.2875 19.0044 22.3875L19.8169 9.79997C19.8544 9.28747 20.3044 8.89997 20.8169 8.92497C21.3294 8.96247 21.7294 9.39997 21.6919 9.92497L20.8794 22.5125C20.7419 24.4625 20.5669 26.875 16.2044 26.875Z"
        fill="currentColor"
      />
      <path
        d="M14.266 20H10.1035C9.59102 20 9.16602 19.575 9.16602 19.0625C9.16602 18.55 9.59102 18.125 10.1035 18.125H14.266C14.7785 18.125 15.2035 18.55 15.2035 19.0625C15.2035 19.575 14.7785 20 14.266 20Z"
        fill="currentColor"
      />
      <path
        d="M15.3164 15H9.06641C8.55391 15 8.12891 14.575 8.12891 14.0625C8.12891 13.55 8.55391 13.125 9.06641 13.125H15.3164C15.8289 13.125 16.2539 13.55 16.2539 14.0625C16.2539 14.575 15.8289 15 15.3164 15Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default DeleteLineIcon;
